// extracted by mini-css-extract-plugin
export var alt = "global-module--alt--3232e";
export var desktopOnly = "global-module--desktopOnly--62b4f";
export var main = "global-module--main--e0c83";
export var mobileOnly = "global-module--mobileOnly--72334";
export var textLeft = "global-module--textLeft--30af4";
export var visuallyHidden = "global-module--visuallyHidden--71e59";